/**
 * Модуль для А/Б-тестирования нового рекомендатора
 */

import { isSSR } from 'src/helpers/ssr';
import type { SearchType } from 'src/types/search';
import { getFlagSigmaHasAnOption } from '..';

const SEARCH_VISITED_KEY = 'lt-visited-search';
const SEARCH_VISITED_VALUE = 'visit';

type RecommenderType = 'default' | 'old' | 'new';

interface RecommenderResult {
  type: RecommenderType;
  group: string;
}

// Позволяет задать тип рекомендатора через query-параметр ?recommenderType=new|old
function getRecommenderTypeFromUrl(): RecommenderType | undefined {
  const params = new URLSearchParams(window.location.search);
  const type = params.get('recommenderType');

  if (type === 'new' || type === 'old' || type === 'default') return type;

  return undefined;
}

/**
 * Использовать данную функцию для аналитики на страницах:
 * Search
 */
export async function getRecommenderTypeForSearchPages(
  isMobile: boolean,
  searchType: SearchType,
): Promise<RecommenderResult> {
  const urlType = getRecommenderTypeFromUrl();
  if (urlType) {
    return { type: urlType, group: 'developer' };
  }

  if (isSSR || isMobile || searchType !== 'package') {
    return { type: 'default', group: 'default' };
  }

  const isNewRecommender = await getFlagSigmaHasAnOption(
    'new_recommender',
    true,
  );

  localStorage.setItem(SEARCH_VISITED_KEY, SEARCH_VISITED_VALUE);

  if (isNewRecommender === undefined) {
    return { type: 'default', group: 'default' };
  }

  const type: RecommenderType = isNewRecommender ? 'new' : 'old';
  return { type, group: type };
}

/**
 * Использовать данную функцию для аналитики на остальных страницах
 */
export async function getRecommenderType(
  isMobile: boolean,
  searchType: SearchType,
): Promise<RecommenderResult> {
  const urlType = getRecommenderTypeFromUrl();
  if (urlType) {
    return { type: urlType, group: 'developer' };
  }

  if (isSSR || isMobile || searchType !== 'package') {
    return { type: 'default', group: 'default' };
  }
  const isNewRecommender = await getFlagSigmaHasAnOption(
    'new_recommender',
    true,
  );

  const isSearchVisited =
    localStorage.getItem(SEARCH_VISITED_KEY) === SEARCH_VISITED_VALUE;

  if (isNewRecommender === undefined || !isSearchVisited) {
    return { type: 'default', group: 'default' };
  }

  const type: RecommenderType = isNewRecommender ? 'new' : 'old';
  return { type, group: type };
}
